export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11435.50f87761.jpg";